import { GetVoidProyectoEvntDTO, ProyectoEvntDTO } from "./EventoProyDTO";


export interface EvntAdjuntarProyectoDTO
{ 
    tituloProducto: string,
    evento: ProyectoEvntDTO
}

export function getVoidEvntAdjuntarProyectoDTO(){
    let evento: ProyectoEvntDTO = GetVoidProyectoEvntDTO();
    let titulo = "";
    return{
        tituloProducto: titulo,
        evento: evento
    }
}

export function GetEvntAdjuntarProyectoDTO(evnt: ProyectoEvntDTO, titulo:string):EvntAdjuntarProyectoDTO{
    let evento: EvntAdjuntarProyectoDTO = getVoidEvntAdjuntarProyectoDTO();
    evento.tituloProducto = titulo;
    evento.evento = evnt;
    return evento;
}